import { createCloudSaveRepository } from "@/features/hoverIdle/persistence/cloudSaveRepository";
import type { HoverIdleSaveStorage } from "@/features/hoverIdle/persistence/hoverIdleStorage";
import { createLocalSaveRepository } from "@/features/hoverIdle/persistence/localSaveRepository";
import { createSyncedSaveStorage } from "@/features/hoverIdle/persistence/saveSyncService";
import type { PlayerOwner } from "@/features/payment/types";
import { isSupabaseConfigured } from "@/integrations/supabase/supabaseConfig";

export async function createDefaultSaveStorage(
  playerOwner: PlayerOwner,
): Promise<HoverIdleSaveStorage> {
  const local = createLocalSaveRepository();

  const cloud =
    playerOwner.ownerKind === "local" || !isSupabaseConfigured()
      ? null
      : createCloudSaveRepository(
          (
            await import("@/integrations/supabase/supabaseClient")
          ).getSupabaseBrowserClient(),
        );
  return createSyncedSaveStorage({
    ownerId: playerOwner.ownerId,
    local,
    cloud,
  });
}
